import * as React from "react";
import { Input, Button, Form } from "antd";
import { Modal } from "Components/General/Modal/GenericModal";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { I18N_NS } from "Config/i18n";
import { loginStore } from "Stores";
import { RouterStore } from "Config/CustomBrowserRouter";

interface ConfirmPasswordProps extends WithTranslation {
  onSuccess: () => void;
}

export const ConfirmPassword = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<ConfirmPasswordProps> {
      handleSubmit = async (values) => {
        try {
          await loginStore.login({ password: values.password });
        } catch (error) {
          RouterStore.push("/dashboard");
          throw error;
        }
      };

      render() {
        const { t } = this.props;
        return (
          <Modal
            title={t("Confirm access to project")}
            open={true}
            footer={null}
            width="100%"
            style={{ maxWidth: 600 }}
            onCancel={() => RouterStore.push("/dashboard")}
          >
            <Form onFinish={this.handleSubmit} requiredMark={false}>
              <Form.Item name="password" rules={[{ required: true, message: t("This field is required") }]}>
                <Input.Password placeholder={t("Password", { ns: I18N_NS.LOGIN })} />
              </Form.Item>
              <div className="text-right">
                <Button type="primary" htmlType="submit" loading={loginStore.state === "LOADING"}>
                  {t("Submit")}
                </Button>
              </div>
            </Form>
          </Modal>
        );
      }
    }
  )
);
